import './menu_overlay.less';
import React from 'react';


export default function MenuOverlay({ closeMenu }) {
  return <div className="menu-overlay" onClick={closeMenu}/>;
}
